var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 101,
    viewBox: "0 0 90 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_519_124",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 91,
    height: 101
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.0068 0.00292969H0.000732422V100.41H90.0068V0.00292969Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_519_124)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.7323 100.411H52.7236C52.0828 100.411 51.4686 100.157 51.0161 99.7036C50.5626 99.2506 50.3082 98.6359 50.3082 97.9951V57.2059C50.3082 51.5016 52.5746 46.0303 56.6081 41.9964C60.6426 37.9625 66.1132 35.6954 71.818 35.6954H76.619C82.0854 35.6954 86.517 40.1271 86.517 45.5934V97.989C86.517 98.6319 86.2615 99.2476 85.808 99.7016C85.3535 100.156 84.7371 100.411 84.0952 100.411H81.0613V72.2437C81.0613 66.9643 76.7372 62.6772 71.3965 62.6772C66.3815 62.6772 62.2628 66.459 61.7657 71.2915L61.7636 71.3206L61.7742 71.6893L61.8605 72.0428L62.0148 72.3723L62.2373 72.6666L62.5141 72.9087L62.8313 73.0875L63.1783 73.198L63.5456 73.2361C64.0981 73.2361 64.8198 73.2351 65.3585 73.217L65.6885 73.1859L66.0004 73.0965L66.2857 72.9529L66.538 72.763L66.753 72.531L66.9244 72.2618L67.0447 71.9605L67.1096 71.635C67.4098 69.5618 69.2174 67.9738 71.3965 67.9738C73.7853 67.9738 75.727 69.8822 75.727 72.2437C75.727 72.2799 75.7291 72.315 75.7323 72.3492V100.411Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7994 41.9485C28.4912 41.9485 31.0731 43.0183 32.9754 44.9211C34.8788 46.8249 35.9484 49.4055 35.9484 52.0969C35.9484 66.0446 35.9484 90.2878 35.9484 97.9898C35.9484 98.6314 35.6926 99.2475 35.2392 99.7021C34.7848 100.156 34.1686 100.411 33.5271 100.411C26.9757 100.411 8.9606 100.411 2.41657 100.411C1.77506 100.411 1.16103 100.157 0.707643 99.703C0.25531 99.2502 0.000610352 98.6359 0.000610352 97.9953C0.000610352 91.6226 0.000610352 73.8964 0.000610352 60.0685C0.000610352 55.2628 1.90928 50.6541 5.30706 47.2559C8.7059 43.8577 13.3148 41.9485 18.1203 41.9485C20.7604 41.9485 23.3961 41.9485 25.7994 41.9485Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2661 35.6483C30.2698 35.6483 35.9475 29.9033 35.9475 22.8164C35.9475 15.7295 30.2698 9.98438 23.2661 9.98438C16.2624 9.98438 10.5847 15.7295 10.5847 22.8164C10.5847 29.9033 16.2624 35.6483 23.2661 35.6483Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2496 30.4053C82.9514 30.4053 90.0056 23.5999 90.0056 15.205C90.0056 6.81006 82.9514 0.00463867 74.2496 0.00463867C65.5477 0.00463867 58.4935 6.81006 58.4935 15.205C58.4935 23.5999 65.5477 30.4053 74.2496 30.4053Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAge);
export default __webpack_public_path__ + "static/media/icon_age.58aa6bed8fb5d4e76d9c18003866f6ce.svg";
export { ForwardRef as ReactComponent };